__turbopack_context__.v({
  "authorBadge": "ExecutiveQuoteSection-module-scss-module__23wZlG__authorBadge",
  "authorInfo": "ExecutiveQuoteSection-module-scss-module__23wZlG__authorInfo",
  "avatar": "ExecutiveQuoteSection-module-scss-module__23wZlG__avatar",
  "avatarWrapper": "ExecutiveQuoteSection-module-scss-module__23wZlG__avatarWrapper",
  "container": "ExecutiveQuoteSection-module-scss-module__23wZlG__container",
  "content": "ExecutiveQuoteSection-module-scss-module__23wZlG__content",
  "linkedInLink": "ExecutiveQuoteSection-module-scss-module__23wZlG__linkedInLink",
  "quote": "ExecutiveQuoteSection-module-scss-module__23wZlG__quote",
  "quoteMark": "ExecutiveQuoteSection-module-scss-module__23wZlG__quoteMark",
  "quoteWrapper": "ExecutiveQuoteSection-module-scss-module__23wZlG__quoteWrapper",
  "root": "ExecutiveQuoteSection-module-scss-module__23wZlG__root",
});
